import React, { Fragment } from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';

const NumberStats = ({ numberdata, locale, currencyRate }) => {
    const numberFormat = (value) =>
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'NZD'
        }).format(value).replace(/(\.|,)00$/g, '');
    return (<Fragment>
        <div className="iconcards-row row d-flex">
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-globe-2"></i>
                        <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id="dashboards.active-groups" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {numberdata.activeGroups}
                        </p>
                    </div>

                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-shop"></i>
                        <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id="dashboards.active-properties" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {numberdata.activeProperties}
                        </p>
                    </div>

                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-shop-2"></i>
                        <p className="card-text font-weight-semibold mb-0">
                            <IntlMessages id="dashboards.live-properties" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {numberdata.liveProperties}
                        </p>
                    </div>

                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-pricing"></i>
                        <p className="card-text font-weight-semibold mb-0">
                            MRR (in NZD)
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {numberFormat(Math.round(numberdata.mrr))}
                        </p>
                    </div>

                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-pricing"></i>
                        <p className="card-text font-weight-semibold mb-0">
                            Average MRR (in NZD)
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                            {numberFormat(Math.round(numberdata.averageMRR))}
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </Fragment>)
}
export default NumberStats;